import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface DeactivationCategory {
  _id?: string;
  code: string;
  name: string;
  message_for_client: string;
  option_indexes: number[];
  automatic_keywords: string[];
  order?: number;
  status?: boolean;
  created_at?: string;
  updated_at?: string;
}

@Injectable({ providedIn: 'root' })
export class DeactivationCategoriesService {
  private baseUrl: string;

  constructor(private http: HttpClient) {
    this.baseUrl = environment.BASE_LA;
  }

  list = async (onlyActive: boolean = false) => {
    const qs = onlyActive ? '?onlyActive=true' : '';
    return lastValueFrom(
      this.http.get<{ ok: boolean; items: DeactivationCategory[] }>(
        `${this.baseUrl}/api/app-config/deactivation-categories${qs}`
      )
    );
  };

  getAssignmentMap = async (excludeId: string | null = null) => {
    const qs = excludeId ? `?exclude_id=${encodeURIComponent(excludeId)}` : '';
    return lastValueFrom(
      this.http.get<{
        ok: boolean;
        options: { [index: number]: { category_code: string; category_name: string } };
        keywords: { [kw: string]: { category_code: string; category_name: string } };
      }>(`${this.baseUrl}/api/app-config/deactivation-categories/assignment-map${qs}`)
    );
  };

  getOne = async (id: string) => {
    return lastValueFrom(
      this.http.get<{ ok: boolean; item: DeactivationCategory }>(
        `${this.baseUrl}/api/app-config/deactivation-categories/${id}`
      )
    );
  };

  create = async (body: Partial<DeactivationCategory>) => {
    return lastValueFrom(
      this.http.post<{ ok: boolean; item: DeactivationCategory; error?: string }>(
        `${this.baseUrl}/api/app-config/deactivation-categories`,
        body
      )
    );
  };

  update = async (id: string, body: Partial<DeactivationCategory>) => {
    return lastValueFrom(
      this.http.put<{ ok: boolean; item: DeactivationCategory; error?: string }>(
        `${this.baseUrl}/api/app-config/deactivation-categories/${id}`,
        body
      )
    );
  };

  delete = async (id: string) => {
    return lastValueFrom(
      this.http.delete<{ ok: boolean; error?: string }>(
        `${this.baseUrl}/api/app-config/deactivation-categories/${id}`
      )
    );
  };
}
